module.exports = __webpack_public_path__ + "static/media/deleted.08bc2457.png";